import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { Template } from 'src/app/models/template';
import { Language } from 'src/app/models/language';

export const getTemplates = createAction('[Template] Get Templates', props<{ studyId: number }>());

export const getTemplatesSuccess = createAction('[Template] Get Templates Success', props<{ templates: Template[] }>());

export const getTemplatesError = createAction('[Template] Get Templates Error', props<{ err: HttpErrorResponse }>());

export const setSelectedTemplate = createAction(
  '[Template] Set Selected Template',
  props<{ selectedTemplate: Template }>()
);

export const getTemplate = createAction('[Template] Get Template ', props<{ templateId: number }>());

export const getTemplateSuccess = createAction(
  '[Template] Get Template Success',
  props<{ selectedTemplate: Template }>()
);

export const getTemplateError = createAction('[Template] Get Template Error', props<{ err: HttpErrorResponse }>());

export const addTemplateSupportedLanguages = createAction(
  '[Template] Add Template Supported Languages',
  props<{ supportedLanguages: Language[] }>()
);

export const setSelectedLanguage = createAction(
  '[Template] Set Selected Language',
  props<{ selectedLanguage: Language }>()
);

export const createTemplate = createAction('[Template] Create Template', props<{ template: Template }>());

export const createTemplateSuccess = createAction(
  '[Template] Create Template Success',
  props<{ createdTemplate: Template }>()
);

export const createTemplateError = createAction(
  '[Template] Create Template Error',
  props<{ err: HttpErrorResponse }>()
);

export const updateTemplate = createAction('[Template] Update Template', props<{ template: Template }>());

export const updateTemplateSuccess = createAction(
  '[Template] Update Template Success',
  props<{ updatedTemplate: Template }>()
);

export const updateTemplateError = createAction(
  '[Template] Update Template Error',
  props<{ err: HttpErrorResponse }>()
);

export const deleteTemplate = createAction('[Template] Delete Template', props<{ template: Template }>());

export const deleteTemplateSuccess = createAction(
  '[Template] Delete Template Success',
  props<{ deletedTemplate: Template }>()
);

export const deleteTemplateError = createAction(
  '[Template] Delete Template Error',
  props<{ err: HttpErrorResponse }>()
);

export const importTemplate = createAction(
  '[Template] Import Template',
  props<{ studyId: number; importFile: File }>()
);

export const importTemplateSuccess = createAction(
  '[Template] Import Template Success',
  props<{ importedTemplate: Template }>()
);

export const importTemplateError = createAction(
  '[Template] Import Template Error',
  props<{ err: HttpErrorResponse }>()
);

export const exportTemplate = createAction('[Template] Export Template', props<{ template: Template }>());

export const setTemplateAsReady = createAction('[Template] Set Template As Ready', props<{ template: Template }>());

export const setTemplateAsReadySuccess = createAction(
  '[Template] Set Template As Ready Success',
  props<{ updatedTemplate: Template }>()
);

export const setTemplateAsReadyError = createAction(
  '[Template] Set Template As Ready Error',
  props<{ err: HttpErrorResponse }>()
);
